import classNames from 'classnames';
import { Nav, NavItem, NavLink } from 'reactstrap';

interface PaymentMethodTabsProps {
  readonly activeTab: 'card' | 'ach';
  readonly onTabChange: (tab: 'card' | 'ach') => void;
  readonly cardContent: React.ReactNode;
  readonly achContent: React.ReactNode;
}

// AIDEV-NOTE: Tab component for payment method selection
export default function PaymentMethodTabs({
  activeTab,
  onTabChange,
  cardContent,
  achContent,
}: PaymentMethodTabsProps) {
  return (
    <>
      <Nav pills className="mb-3">
        <NavItem>
          <NavLink
            className={classNames({ active: activeTab === 'card' })}
            onClick={() => onTabChange('card')}
            style={{ cursor: 'pointer' }}
          >
            Credit/Debit Card
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classNames({ active: activeTab === 'ach' })}
            onClick={() => onTabChange('ach')}
            style={{ cursor: 'pointer' }}
          >
            ACH Payment
          </NavLink>
        </NavItem>
      </Nav>

      {activeTab === 'card' && cardContent}
      {activeTab === 'ach' && achContent}
    </>
  );
}
